export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || ''
export const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || ''
